export var Format;
(function (Format) {
    Format["UNDEFINED"] = "UNDEFINED";
    Format["DATE"] = "DATE";
    Format["TIME"] = "TIME";
    Format["DATE_TIME"] = "DATE_TIME";
    Format["EMAIL"] = "EMAIL";
    Format["URL"] = "URL";
    Format["UUID"] = "UUID";
    Format["PHONE"] = "PHONE";
    Format["URI"] = "URI";
    Format["HOSTNAME"] = "HOSTNAME";
    Format["COLOR_HEX"] = "COLOR_HEX";
    Format["CURRENCY"] = "CURRENCY";
    Format["LANGUAGE"] = "LANGUAGE";
    Format["DATE_OPTIONAL_TIME"] = "DATE_OPTIONAL_TIME";
})(Format || (Format = {}));
export var ValidationFormat;
(function (ValidationFormat) {
    ValidationFormat["UNDEFINED"] = "UNDEFINED";
    /** File upload validation. */
    ValidationFormat["WIX_FILE"] = "WIX_FILE";
    /** Payment validation. */
    ValidationFormat["PAYMENT"] = "PAYMENT";
    /** Multiline address. */
    ValidationFormat["MULTILINE_ADDRESS"] = "MULTILINE_ADDRESS";
    /** Scheduling validation. */
    ValidationFormat["SCHEDULING"] = "SCHEDULING";
    /** Object array validation. */
    ValidationFormat["OBJECT_ARRAY"] = "OBJECT_ARRAY";
})(ValidationFormat || (ValidationFormat = {}));
export var ProductType;
(function (ProductType) {
    /** Unknown product type. */
    ProductType["UNKNOWN_PRODUCT_TYPE"] = "UNKNOWN_PRODUCT_TYPE";
    /** Physical product that can be shipped. */
    ProductType["SHIPPABLE"] = "SHIPPABLE";
    /** Digital product. */
    ProductType["DIGITAL"] = "DIGITAL";
})(ProductType || (ProductType = {}));
export var PriceType;
(function (PriceType) {
    /** Unknown price type. */
    PriceType["UNKNOWN_PRICE_TYPE"] = "UNKNOWN_PRICE_TYPE";
    /** Product has a single, unchanging price. */
    PriceType["FIXED_PRICE"] = "FIXED_PRICE";
    /** Product price can vary within a specified range. */
    PriceType["DYNAMIC_PRICE"] = "DYNAMIC_PRICE";
})(PriceType || (PriceType = {}));
export var FieldFieldType;
(function (FieldFieldType) {
    /** Unknown field type. */
    FieldFieldType["UNKNOWN_FIELD_TYPE"] = "UNKNOWN_FIELD_TYPE";
    /** Input field that collects data from users. */
    FieldFieldType["INPUT"] = "INPUT";
    /** Display field that shows information without collecting input. */
    FieldFieldType["DISPLAY"] = "DISPLAY";
})(FieldFieldType || (FieldFieldType = {}));
export var StringTypeFormatEnumFormat;
(function (StringTypeFormatEnumFormat) {
    /** Unknown format. */
    StringTypeFormatEnumFormat["UNKNOWN_FORMAT"] = "UNKNOWN_FORMAT";
    /** Date format. */
    StringTypeFormatEnumFormat["DATE"] = "DATE";
    /** Time format. */
    StringTypeFormatEnumFormat["TIME"] = "TIME";
    /** Date and time format. */
    StringTypeFormatEnumFormat["DATE_TIME"] = "DATE_TIME";
    /** Email format. */
    StringTypeFormatEnumFormat["EMAIL"] = "EMAIL";
    /** URL format. */
    StringTypeFormatEnumFormat["URL"] = "URL";
    /** UUID format. */
    StringTypeFormatEnumFormat["UUID"] = "UUID";
    /** Phone number format. */
    StringTypeFormatEnumFormat["PHONE"] = "PHONE";
    /** URI format. */
    StringTypeFormatEnumFormat["URI"] = "URI";
    /** Hostname format. */
    StringTypeFormatEnumFormat["HOSTNAME"] = "HOSTNAME";
    /** Hexadecimal color code format. */
    StringTypeFormatEnumFormat["COLOR_HEX"] = "COLOR_HEX";
    /** Currency format. */
    StringTypeFormatEnumFormat["CURRENCY"] = "CURRENCY";
    /** Language code format. */
    StringTypeFormatEnumFormat["LANGUAGE"] = "LANGUAGE";
    /** Date with optional time format. */
    StringTypeFormatEnumFormat["DATE_OPTIONAL_TIME"] = "DATE_OPTIONAL_TIME";
})(StringTypeFormatEnumFormat || (StringTypeFormatEnumFormat = {}));
export var InputFieldStringComponentType;
(function (InputFieldStringComponentType) {
    /** Unknown component type. */
    InputFieldStringComponentType["UNKNOWN_COMPONENT_TYPE"] = "UNKNOWN_COMPONENT_TYPE";
    /** Text input component. */
    InputFieldStringComponentType["TEXT_INPUT"] = "TEXT_INPUT";
    /** Radio group component. */
    InputFieldStringComponentType["RADIO_GROUP"] = "RADIO_GROUP";
    /** Dropdown component. */
    InputFieldStringComponentType["DROPDOWN"] = "DROPDOWN";
    /** Date and time component. */
    InputFieldStringComponentType["DATE_TIME"] = "DATE_TIME";
    /** Phone number component. */
    InputFieldStringComponentType["PHONE_INPUT"] = "PHONE_INPUT";
    /** Date selection component. */
    InputFieldStringComponentType["DATE_INPUT"] = "DATE_INPUT";
    /** Time selection component. */
    InputFieldStringComponentType["TIME_INPUT"] = "TIME_INPUT";
    /** Calendar-style date picker component. */
    InputFieldStringComponentType["DATE_PICKER"] = "DATE_PICKER";
    /** Dropdown component for selecting available services. */
    InputFieldStringComponentType["SERVICES_DROPDOWN"] = "SERVICES_DROPDOWN";
})(InputFieldStringComponentType || (InputFieldStringComponentType = {}));
export var NodeType;
(function (NodeType) {
    NodeType["PARAGRAPH"] = "PARAGRAPH";
    NodeType["TEXT"] = "TEXT";
    NodeType["HEADING"] = "HEADING";
    NodeType["BULLETED_LIST"] = "BULLETED_LIST";
    NodeType["ORDERED_LIST"] = "ORDERED_LIST";
    NodeType["LIST_ITEM"] = "LIST_ITEM";
    NodeType["BLOCKQUOTE"] = "BLOCKQUOTE";
    NodeType["CODE_BLOCK"] = "CODE_BLOCK";
    NodeType["VIDEO"] = "VIDEO";
    NodeType["DIVIDER"] = "DIVIDER";
    NodeType["FILE"] = "FILE";
    NodeType["GALLERY"] = "GALLERY";
    NodeType["GIF"] = "GIF";
    NodeType["HTML"] = "HTML";
    NodeType["IMAGE"] = "IMAGE";
    NodeType["LINK_PREVIEW"] = "LINK_PREVIEW";
    /** @deprecated */
    NodeType["MAP"] = "MAP";
    NodeType["POLL"] = "POLL";
    NodeType["APP_EMBED"] = "APP_EMBED";
    NodeType["BUTTON"] = "BUTTON";
    NodeType["COLLAPSIBLE_LIST"] = "COLLAPSIBLE_LIST";
    NodeType["TABLE"] = "TABLE";
    NodeType["EMBED"] = "EMBED";
    NodeType["COLLAPSIBLE_ITEM"] = "COLLAPSIBLE_ITEM";
    NodeType["COLLAPSIBLE_ITEM_TITLE"] = "COLLAPSIBLE_ITEM_TITLE";
    NodeType["COLLAPSIBLE_ITEM_BODY"] = "COLLAPSIBLE_ITEM_BODY";
    NodeType["TABLE_CELL"] = "TABLE_CELL";
    NodeType["TABLE_ROW"] = "TABLE_ROW";
    NodeType["EXTERNAL"] = "EXTERNAL";
    NodeType["AUDIO"] = "AUDIO";
    NodeType["CAPTION"] = "CAPTION";
    NodeType["LAYOUT"] = "LAYOUT";
    NodeType["LAYOUT_CELL"] = "LAYOUT_CELL";
})(NodeType || (NodeType = {}));
export var WidthType;
(function (WidthType) {
    /** Width matches the content width */
    WidthType["CONTENT"] = "CONTENT";
    /** Small Width */
    WidthType["SMALL"] = "SMALL";
    /** Width will match the original asset width */
    WidthType["ORIGINAL"] = "ORIGINAL";
    /** coast-to-coast display */
    WidthType["FULL_WIDTH"] = "FULL_WIDTH";
})(WidthType || (WidthType = {}));
export var PluginContainerDataAlignment;
(function (PluginContainerDataAlignment) {
    /** Center Alignment */
    PluginContainerDataAlignment["CENTER"] = "CENTER";
    /** Left Alignment */
    PluginContainerDataAlignment["LEFT"] = "LEFT";
    /** Right Alignment */
    PluginContainerDataAlignment["RIGHT"] = "RIGHT";
})(PluginContainerDataAlignment || (PluginContainerDataAlignment = {}));
export var Type;
(function (Type) {
    /** Regular link button */
    Type["LINK"] = "LINK";
    /** Triggers custom action that is defined in plugin configuration by the consumer */
    Type["ACTION"] = "ACTION";
})(Type || (Type = {}));
export var Target;
(function (Target) {
    /** Opens the linked document in the same frame as it was clicked (this is default) */
    Target["SELF"] = "SELF";
    /** Opens the linked document in a new window or tab */
    Target["BLANK"] = "BLANK";
    /** Opens the linked document in the parent frame */
    Target["PARENT"] = "PARENT";
    /** Opens the linked document in the full body of the window */
    Target["TOP"] = "TOP";
})(Target || (Target = {}));
export var TextAlignment;
(function (TextAlignment) {
    /** browser default, eqivalent to `initial` */
    TextAlignment["AUTO"] = "AUTO";
    /** Left align */
    TextAlignment["LEFT"] = "LEFT";
    /** Right align */
    TextAlignment["RIGHT"] = "RIGHT";
    /** Center align */
    TextAlignment["CENTER"] = "CENTER";
    /** Text is spaced to line up its left and right edges to the left and right edges of the line box, except for the last line */
    TextAlignment["JUSTIFY"] = "JUSTIFY";
})(TextAlignment || (TextAlignment = {}));
export var LineStyle;
(function (LineStyle) {
    /** Single Line */
    LineStyle["SINGLE"] = "SINGLE";
    /** Double Line */
    LineStyle["DOUBLE"] = "DOUBLE";
    /** Dashed Line */
    LineStyle["DASHED"] = "DASHED";
    /** Dotted Line */
    LineStyle["DOTTED"] = "DOTTED";
})(LineStyle || (LineStyle = {}));
export var Width;
(function (Width) {
    /** Large line */
    Width["LARGE"] = "LARGE";
    /** Medium line */
    Width["MEDIUM"] = "MEDIUM";
    /** Small line */
    Width["SMALL"] = "SMALL";
})(Width || (Width = {}));
export var Alignment;
(function (Alignment) {
    /** Center alignment */
    Alignment["CENTER"] = "CENTER";
    /** Left alignment */
    Alignment["LEFT"] = "LEFT";
    /** Right alignment */
    Alignment["RIGHT"] = "RIGHT";
})(Alignment || (Alignment = {}));
export var ViewMode;
(function (ViewMode) {
    /** No PDF view */
    ViewMode["NONE"] = "NONE";
    /** Full PDF view */
    ViewMode["FULL"] = "FULL";
    /** Mini PDF view */
    ViewMode["MINI"] = "MINI";
})(ViewMode || (ViewMode = {}));
export var LayoutType;
(function (LayoutType) {
    /** Collage type */
    LayoutType["COLLAGE"] = "COLLAGE";
    /** Masonry type */
    LayoutType["MASONRY"] = "MASONRY";
    /** Grid type */
    LayoutType["GRID"] = "GRID";
    /** Thumbnail type */
    LayoutType["THUMBNAIL"] = "THUMBNAIL";
    /** Slider type */
    LayoutType["SLIDER"] = "SLIDER";
    /** Slideshow type */
    LayoutType["SLIDESHOW"] = "SLIDESHOW";
    /** Panorama type */
    LayoutType["PANORAMA"] = "PANORAMA";
    /** Column type */
    LayoutType["COLUMN"] = "COLUMN";
    /** Magic type */
    LayoutType["MAGIC"] = "MAGIC";
    /** Fullsize images type */
    LayoutType["FULLSIZE"] = "FULLSIZE";
})(LayoutType || (LayoutType = {}));
export var Orientation;
(function (Orientation) {
    /** Rows Orientation */
    Orientation["ROWS"] = "ROWS";
    /** Columns Orientation */
    Orientation["COLUMNS"] = "COLUMNS";
})(Orientation || (Orientation = {}));
export var Crop;
(function (Crop) {
    /** Crop to fill */
    Crop["FILL"] = "FILL";
    /** Crop to fit */
    Crop["FIT"] = "FIT";
})(Crop || (Crop = {}));
export var ThumbnailsAlignment;
(function (ThumbnailsAlignment) {
    /** Top alignment */
    ThumbnailsAlignment["TOP"] = "TOP";
    /** Right alignment */
    ThumbnailsAlignment["RIGHT"] = "RIGHT";
    /** Bottom alignment */
    ThumbnailsAlignment["BOTTOM"] = "BOTTOM";
    /** Left alignment */
    ThumbnailsAlignment["LEFT"] = "LEFT";
    /** No thumbnail */
    ThumbnailsAlignment["NONE"] = "NONE";
})(ThumbnailsAlignment || (ThumbnailsAlignment = {}));
export var GIFType;
(function (GIFType) {
    GIFType["NORMAL"] = "NORMAL";
    GIFType["STICKER"] = "STICKER";
})(GIFType || (GIFType = {}));
export var Source;
(function (Source) {
    Source["HTML"] = "HTML";
    Source["ADSENSE"] = "ADSENSE";
    Source["AI"] = "AI";
})(Source || (Source = {}));
export var Position;
(function (Position) {
    /** Thumbnail positioned at the start (left in LTR layouts, right in RTL layouts) */
    Position["START"] = "START";
    /** Thumbnail positioned at the end (right in LTR layouts, left in RTL layouts) */
    Position["END"] = "END";
    /** Thumbnail positioned at the top */
    Position["TOP"] = "TOP";
    /** Thumbnail hidden and not displayed */
    Position["HIDDEN"] = "HIDDEN";
})(Position || (Position = {}));
export var MapType;
(function (MapType) {
    /** Roadmap map type */
    MapType["ROADMAP"] = "ROADMAP";
    /** Satellite map type */
    MapType["SATELITE"] = "SATELITE";
    /** Hybrid map type */
    MapType["HYBRID"] = "HYBRID";
    /** Terrain map type */
    MapType["TERRAIN"] = "TERRAIN";
})(MapType || (MapType = {}));
export var ViewRole;
(function (ViewRole) {
    /** Only Poll creator can view the results */
    ViewRole["CREATOR"] = "CREATOR";
    /** Anyone who voted can see the results */
    ViewRole["VOTERS"] = "VOTERS";
    /** Anyone can see the results, even if one didn't vote */
    ViewRole["EVERYONE"] = "EVERYONE";
})(ViewRole || (ViewRole = {}));
export var VoteRole;
(function (VoteRole) {
    /** Logged in member */
    VoteRole["SITE_MEMBERS"] = "SITE_MEMBERS";
    /** Anyone */
    VoteRole["ALL"] = "ALL";
})(VoteRole || (VoteRole = {}));
export var PollLayoutType;
(function (PollLayoutType) {
    /** List */
    PollLayoutType["LIST"] = "LIST";
    /** Grid */
    PollLayoutType["GRID"] = "GRID";
})(PollLayoutType || (PollLayoutType = {}));
export var PollLayoutDirection;
(function (PollLayoutDirection) {
    /** Left-to-right */
    PollLayoutDirection["LTR"] = "LTR";
    /** Right-to-left */
    PollLayoutDirection["RTL"] = "RTL";
})(PollLayoutDirection || (PollLayoutDirection = {}));
export var BackgroundType;
(function (BackgroundType) {
    /** Color background type */
    BackgroundType["COLOR"] = "COLOR";
    /** Image background type */
    BackgroundType["IMAGE"] = "IMAGE";
    /** Gradiant background type */
    BackgroundType["GRADIENT"] = "GRADIENT";
})(BackgroundType || (BackgroundType = {}));
export var DecorationType;
(function (DecorationType) {
    DecorationType["BOLD"] = "BOLD";
    DecorationType["ITALIC"] = "ITALIC";
    DecorationType["UNDERLINE"] = "UNDERLINE";
    DecorationType["SPOILER"] = "SPOILER";
    DecorationType["ANCHOR"] = "ANCHOR";
    DecorationType["MENTION"] = "MENTION";
    DecorationType["LINK"] = "LINK";
    DecorationType["COLOR"] = "COLOR";
    DecorationType["FONT_SIZE"] = "FONT_SIZE";
    DecorationType["EXTERNAL"] = "EXTERNAL";
    DecorationType["STRIKETHROUGH"] = "STRIKETHROUGH";
    DecorationType["SUPERSCRIPT"] = "SUPERSCRIPT";
    DecorationType["SUBSCRIPT"] = "SUBSCRIPT";
    DecorationType["FONT_FAMILY"] = "FONT_FAMILY";
})(DecorationType || (DecorationType = {}));
export var FontType;
(function (FontType) {
    FontType["PX"] = "PX";
    FontType["EM"] = "EM";
})(FontType || (FontType = {}));
export var ImageStylesPosition;
(function (ImageStylesPosition) {
    /** Image positioned at the start (left in LTR layouts, right in RTL layouts) */
    ImageStylesPosition["START"] = "START";
    /** Image positioned at the end (right in LTR layouts, left in RTL layouts) */
    ImageStylesPosition["END"] = "END";
    /** Image positioned at the top */
    ImageStylesPosition["TOP"] = "TOP";
})(ImageStylesPosition || (ImageStylesPosition = {}));
export var AspectRatio;
(function (AspectRatio) {
    /** 1:1 aspect ratio */
    AspectRatio["SQUARE"] = "SQUARE";
    /** 16:9 aspect ratio */
    AspectRatio["RECTANGLE"] = "RECTANGLE";
})(AspectRatio || (AspectRatio = {}));
export var Resizing;
(function (Resizing) {
    /** Fill the container, may crop the image */
    Resizing["FILL"] = "FILL";
    /** Fit the image within the container */
    Resizing["FIT"] = "FIT";
})(Resizing || (Resizing = {}));
export var Placement;
(function (Placement) {
    /** Ribbon placed on the image */
    Placement["IMAGE"] = "IMAGE";
    /** Ribbon placed on the product information */
    Placement["PRODUCT_INFO"] = "PRODUCT_INFO";
})(Placement || (Placement = {}));
export var CardStylesType;
(function (CardStylesType) {
    /** Card with visible border and background */
    CardStylesType["CONTAINED"] = "CONTAINED";
    /** Card without visible border */
    CardStylesType["FRAMELESS"] = "FRAMELESS";
})(CardStylesType || (CardStylesType = {}));
export var CardStylesAlignment;
(function (CardStylesAlignment) {
    /** Content aligned to start (left in LTR layouts, right in RTL layouts) */
    CardStylesAlignment["START"] = "START";
    /** Content centered */
    CardStylesAlignment["CENTER"] = "CENTER";
    /** Content aligned to end (right in LTR layouts, left in RTL layouts) */
    CardStylesAlignment["END"] = "END";
})(CardStylesAlignment || (CardStylesAlignment = {}));
export var CardStylesLayout;
(function (CardStylesLayout) {
    /** Elements stacked vertically */
    CardStylesLayout["STACKED"] = "STACKED";
    /** Elements arranged horizontally */
    CardStylesLayout["SIDE_BY_SIDE"] = "SIDE_BY_SIDE";
})(CardStylesLayout || (CardStylesLayout = {}));
export var AppType;
(function (AppType) {
    AppType["PRODUCT"] = "PRODUCT";
    AppType["EVENT"] = "EVENT";
    AppType["BOOKING"] = "BOOKING";
})(AppType || (AppType = {}));
export var InitialExpandedItems;
(function (InitialExpandedItems) {
    /** First item will be expended initally */
    InitialExpandedItems["FIRST"] = "FIRST";
    /** All items will expended initally */
    InitialExpandedItems["ALL"] = "ALL";
    /** All items collapsed initally */
    InitialExpandedItems["NONE"] = "NONE";
})(InitialExpandedItems || (InitialExpandedItems = {}));
export var Direction;
(function (Direction) {
    /** Left-to-right */
    Direction["LTR"] = "LTR";
    /** Right-to-left */
    Direction["RTL"] = "RTL";
})(Direction || (Direction = {}));
export var VerticalAlignment;
(function (VerticalAlignment) {
    /** Top alignment */
    VerticalAlignment["TOP"] = "TOP";
    /** Middle alignment */
    VerticalAlignment["MIDDLE"] = "MIDDLE";
    /** Bottom alignment */
    VerticalAlignment["BOTTOM"] = "BOTTOM";
})(VerticalAlignment || (VerticalAlignment = {}));
/**
 * `NullValue` is a singleton enumeration to represent the null value for the
 * `Value` type union.
 *
 * The JSON representation for `NullValue` is JSON `null`.
 */
export var NullValue;
(function (NullValue) {
    /** Null value. */
    NullValue["NULL_VALUE"] = "NULL_VALUE";
})(NullValue || (NullValue = {}));
export var Scaling;
(function (Scaling) {
    /** Auto image scaling */
    Scaling["AUTO"] = "AUTO";
    /** Contain image scaling */
    Scaling["CONTAIN"] = "CONTAIN";
    /** Cover image scaling */
    Scaling["COVER"] = "COVER";
})(Scaling || (Scaling = {}));
export var LayoutDataImagePosition;
(function (LayoutDataImagePosition) {
    /** Image positioned at the center */
    LayoutDataImagePosition["CENTER"] = "CENTER";
    /** Image positioned on the left */
    LayoutDataImagePosition["CENTER_LEFT"] = "CENTER_LEFT";
    /** Image positioned on the right */
    LayoutDataImagePosition["CENTER_RIGHT"] = "CENTER_RIGHT";
    /** Image positioned at the center top */
    LayoutDataImagePosition["TOP"] = "TOP";
    /** Image positioned at the top left */
    LayoutDataImagePosition["TOP_LEFT"] = "TOP_LEFT";
    /** Image positioned at the top right */
    LayoutDataImagePosition["TOP_RIGHT"] = "TOP_RIGHT";
    /** Image positioned at the center bottom */
    LayoutDataImagePosition["BOTTOM"] = "BOTTOM";
    /** Image positioned at the bottom left */
    LayoutDataImagePosition["BOTTOM_LEFT"] = "BOTTOM_LEFT";
    /** Image positioned at the bottom right */
    LayoutDataImagePosition["BOTTOM_RIGHT"] = "BOTTOM_RIGHT";
})(LayoutDataImagePosition || (LayoutDataImagePosition = {}));
export var VerticalAlignmentAlignment;
(function (VerticalAlignmentAlignment) {
    /** Top alignment */
    VerticalAlignmentAlignment["TOP"] = "TOP";
    /** Middle alignment */
    VerticalAlignmentAlignment["MIDDLE"] = "MIDDLE";
    /** Bottom alignment */
    VerticalAlignmentAlignment["BOTTOM"] = "BOTTOM";
})(VerticalAlignmentAlignment || (VerticalAlignmentAlignment = {}));
export var ResponsivenessBehaviour;
(function (ResponsivenessBehaviour) {
    /** Stacking of columns */
    ResponsivenessBehaviour["STACK"] = "STACK";
    /** Wrapping of columns */
    ResponsivenessBehaviour["WRAP"] = "WRAP";
})(ResponsivenessBehaviour || (ResponsivenessBehaviour = {}));
export var ImagePosition;
(function (ImagePosition) {
    /** Undefined position. */
    ImagePosition["UNKNOWN_IMAGE_POSITION"] = "UNKNOWN_IMAGE_POSITION";
    /** Above the field's label. */
    ImagePosition["ABOVE"] = "ABOVE";
    /** Below the field's label. */
    ImagePosition["BELOW"] = "BELOW";
})(ImagePosition || (ImagePosition = {}));
export var AlignmentEnumAlignment;
(function (AlignmentEnumAlignment) {
    /** Undefined alignment. */
    AlignmentEnumAlignment["UNKNOWN_ALIGNMENT"] = "UNKNOWN_ALIGNMENT";
    /** Align left. */
    AlignmentEnumAlignment["LEFT"] = "LEFT";
    /** Align center. */
    AlignmentEnumAlignment["CENTER"] = "CENTER";
    /** Align right. */
    AlignmentEnumAlignment["RIGHT"] = "RIGHT";
})(AlignmentEnumAlignment || (AlignmentEnumAlignment = {}));
export var ImageFit;
(function (ImageFit) {
    ImageFit["UNKNOWN_IMAGE_FIT"] = "UNKNOWN_IMAGE_FIT";
    /** Scale the image to maintain its aspect ratio while filling the element's entire content box. Portions of the image may be clipped if the aspect ratios don't match. */
    ImageFit["COVER"] = "COVER";
    /** Resize the image to fill the element's content box. The image's original sspect ratio may not be preserved. */
    ImageFit["CONTAIN"] = "CONTAIN";
})(ImageFit || (ImageFit = {}));
export var NumberOfColumns;
(function (NumberOfColumns) {
    /** Undefined number of columns. */
    NumberOfColumns["UNKNOWN_NUMBER_OF_COLUMNS"] = "UNKNOWN_NUMBER_OF_COLUMNS";
    /** Zero columns. */
    NumberOfColumns["ZERO"] = "ZERO";
    /** One column. */
    NumberOfColumns["ONE"] = "ONE";
    /** Two columns. */
    NumberOfColumns["TWO"] = "TWO";
    /** Three columns. */
    NumberOfColumns["THREE"] = "THREE";
})(NumberOfColumns || (NumberOfColumns = {}));
export var FirstDayOfWeekEnumFirstDayOfWeek;
(function (FirstDayOfWeekEnumFirstDayOfWeek) {
    /** First day of the week is Monday. */
    FirstDayOfWeekEnumFirstDayOfWeek["MONDAY"] = "MONDAY";
    /** First day of the week is Sunday. */
    FirstDayOfWeekEnumFirstDayOfWeek["SUNDAY"] = "SUNDAY";
})(FirstDayOfWeekEnumFirstDayOfWeek || (FirstDayOfWeekEnumFirstDayOfWeek = {}));
export var InputFieldNumberComponentType;
(function (InputFieldNumberComponentType) {
    /** Unknown component type. */
    InputFieldNumberComponentType["UNKNOWN_COMPONENT_TYPE"] = "UNKNOWN_COMPONENT_TYPE";
    /** Numeric input component. */
    InputFieldNumberComponentType["NUMBER_INPUT"] = "NUMBER_INPUT";
    /** Rating input component. */
    InputFieldNumberComponentType["RATING_INPUT"] = "RATING_INPUT";
})(InputFieldNumberComponentType || (InputFieldNumberComponentType = {}));
export var InputFieldBooleanComponentType;
(function (InputFieldBooleanComponentType) {
    /** Unknown component type. */
    InputFieldBooleanComponentType["UNKNOWN_COMPONENT_TYPE"] = "UNKNOWN_COMPONENT_TYPE";
    /** Checkbox component. */
    InputFieldBooleanComponentType["CHECKBOX"] = "CHECKBOX";
})(InputFieldBooleanComponentType || (InputFieldBooleanComponentType = {}));
export var ArrayItemsItemType;
(function (ArrayItemsItemType) {
    /** Unknown item type. */
    ArrayItemsItemType["UNKNOWN_ITEM_TYPE"] = "UNKNOWN_ITEM_TYPE";
    /** Array can contain string values. */
    ArrayItemsItemType["STRING"] = "STRING";
    /** Array can contain numeric values. */
    ArrayItemsItemType["NUMBER"] = "NUMBER";
    /** Array can contain boolean values. */
    ArrayItemsItemType["BOOLEAN"] = "BOOLEAN";
    /** Array can contain object values. */
    ArrayItemsItemType["OBJECT"] = "OBJECT";
})(ArrayItemsItemType || (ArrayItemsItemType = {}));
export var PropertiesTypePropertiesTypeEnum;
(function (PropertiesTypePropertiesTypeEnum) {
    /** Unknown property type. */
    PropertiesTypePropertiesTypeEnum["UNKNOWN_PROPERTY_TYPE"] = "UNKNOWN_PROPERTY_TYPE";
    /** Property must contain a string value. */
    PropertiesTypePropertiesTypeEnum["STRING"] = "STRING";
    /** Property must contain a numeric value. */
    PropertiesTypePropertiesTypeEnum["NUMBER"] = "NUMBER";
    /** Property must contain a boolean value. */
    PropertiesTypePropertiesTypeEnum["BOOLEAN"] = "BOOLEAN";
    /** Property must contain an array. */
    PropertiesTypePropertiesTypeEnum["ARRAY"] = "ARRAY";
})(PropertiesTypePropertiesTypeEnum || (PropertiesTypePropertiesTypeEnum = {}));
export var ArrayComponentType;
(function (ArrayComponentType) {
    /** Unknown component type. */
    ArrayComponentType["UNKNOWN_COMPONENT_TYPE"] = "UNKNOWN_COMPONENT_TYPE";
    /** Checkbox group component. */
    ArrayComponentType["CHECKBOX_GROUP"] = "CHECKBOX_GROUP";
    /** Tags component. */
    ArrayComponentType["TAGS"] = "TAGS";
    ArrayComponentType["SERVICES_CHECKBOX_GROUP"] = "SERVICES_CHECKBOX_GROUP";
})(ArrayComponentType || (ArrayComponentType = {}));
export var InputFieldWixFileComponentType;
(function (InputFieldWixFileComponentType) {
    /** Unknown component type. */
    InputFieldWixFileComponentType["UNKNOWN_COMPONENT_TYPE"] = "UNKNOWN_COMPONENT_TYPE";
    /** File upload component. */
    InputFieldWixFileComponentType["FILE_UPLOAD"] = "FILE_UPLOAD";
    /** Signature component. */
    InputFieldWixFileComponentType["SIGNATURE"] = "SIGNATURE";
})(InputFieldWixFileComponentType || (InputFieldWixFileComponentType = {}));
export var UploadFileFormat;
(function (UploadFileFormat) {
    /** Undefined upload file format. */
    UploadFileFormat["UNKNOWN_UPLOAD_FILE_FORMAT"] = "UNKNOWN_UPLOAD_FILE_FORMAT";
    /** Video files. */
    UploadFileFormat["VIDEO"] = "VIDEO";
    /** Image files. */
    UploadFileFormat["IMAGE"] = "IMAGE";
    /** Audio files. */
    UploadFileFormat["AUDIO"] = "AUDIO";
    /** Document files. */
    UploadFileFormat["DOCUMENT"] = "DOCUMENT";
    /** Archive files. */
    UploadFileFormat["ARCHIVE"] = "ARCHIVE";
})(UploadFileFormat || (UploadFileFormat = {}));
export var InputFieldPaymentComponentType;
(function (InputFieldPaymentComponentType) {
    /** Unknown component type. */
    InputFieldPaymentComponentType["UNKNOWN_COMPONENT_TYPE"] = "UNKNOWN_COMPONENT_TYPE";
    /** Checkbox group component. */
    InputFieldPaymentComponentType["CHECKBOX_GROUP"] = "CHECKBOX_GROUP";
    /** Donation input component. */
    InputFieldPaymentComponentType["DONATION_INPUT"] = "DONATION_INPUT";
    /** Payment input component. */
    InputFieldPaymentComponentType["PAYMENT_INPUT"] = "PAYMENT_INPUT";
    /** Fixed payment component. */
    InputFieldPaymentComponentType["FIXED_PAYMENT"] = "FIXED_PAYMENT";
})(InputFieldPaymentComponentType || (InputFieldPaymentComponentType = {}));
export var AddressComponentType;
(function (AddressComponentType) {
    /** Unknown component type. */
    AddressComponentType["UNKNOWN_COMPONENT_TYPE"] = "UNKNOWN_COMPONENT_TYPE";
    /** Multiline address component. */
    AddressComponentType["MULTILINE_ADDRESS"] = "MULTILINE_ADDRESS";
})(AddressComponentType || (AddressComponentType = {}));
export var DefaultCountryConfigType;
(function (DefaultCountryConfigType) {
    /** Unknown default country configuration type. */
    DefaultCountryConfigType["UNKNOWN_DEFAULT_COUNTRY"] = "UNKNOWN_DEFAULT_COUNTRY";
    /** Country is determined by the submitter's IP address. */
    DefaultCountryConfigType["BY_IP"] = "BY_IP";
    /** Pre-selected default country. */
    DefaultCountryConfigType["COUNTRY"] = "COUNTRY";
})(DefaultCountryConfigType || (DefaultCountryConfigType = {}));
export var ObjectArrayComponentType;
(function (ObjectArrayComponentType) {
    /** Unknown component type. */
    ObjectArrayComponentType["UNKNOWN_COMPONENT_TYPE"] = "UNKNOWN_COMPONENT_TYPE";
    /** Repeater component. */
    ObjectArrayComponentType["REPEATER"] = "REPEATER";
})(ObjectArrayComponentType || (ObjectArrayComponentType = {}));
export var InputFieldSchedulingComponentType;
(function (InputFieldSchedulingComponentType) {
    /** Unknown component type. */
    InputFieldSchedulingComponentType["UNKNOWN_COMPONENT_TYPE"] = "UNKNOWN_COMPONENT_TYPE";
    /** Appointment component. */
    InputFieldSchedulingComponentType["APPOINTMENT"] = "APPOINTMENT";
})(InputFieldSchedulingComponentType || (InputFieldSchedulingComponentType = {}));
export var AppointmentFormat;
(function (AppointmentFormat) {
    AppointmentFormat["UNKNOWN_FORMAT_TYPE"] = "UNKNOWN_FORMAT_TYPE";
    /** Face-to-face meeting at a physical location. */
    AppointmentFormat["IN_PERSON"] = "IN_PERSON";
    /** Online meeting via video conference. */
    AppointmentFormat["VIDEO_CONFERENCE"] = "VIDEO_CONFERENCE";
    /** Appointment conducted over the phone. */
    AppointmentFormat["PHONE"] = "PHONE";
})(AppointmentFormat || (AppointmentFormat = {}));
export var InputFieldInputType;
(function (InputFieldInputType) {
    /** Unknown input type. */
    InputFieldInputType["UNKNOWN_INPUT_TYPE"] = "UNKNOWN_INPUT_TYPE";
    /** String input. */
    InputFieldInputType["STRING"] = "STRING";
    /** Numeric input. */
    InputFieldInputType["NUMBER"] = "NUMBER";
    /** Boolean input. */
    InputFieldInputType["BOOLEAN"] = "BOOLEAN";
    /** Array input. */
    InputFieldInputType["ARRAY"] = "ARRAY";
    /** Object input. */
    InputFieldInputType["OBJECT"] = "OBJECT";
    /** File upload input. */
    InputFieldInputType["WIX_FILE"] = "WIX_FILE";
    /** Payment input. */
    InputFieldInputType["PAYMENT"] = "PAYMENT";
    /** Scheduling input. */
    InputFieldInputType["SCHEDULING"] = "SCHEDULING";
    /** Address input. */
    InputFieldInputType["ADDRESS"] = "ADDRESS";
    /** Multiline address input. */
    InputFieldInputType["MULTILINE_ADDRESS"] = "MULTILINE_ADDRESS";
    /** Array of objects input. */
    InputFieldInputType["OBJECT_ARRAY"] = "OBJECT_ARRAY";
})(InputFieldInputType || (InputFieldInputType = {}));
export var FormFieldContactInfoEmailInfoTag;
(function (FormFieldContactInfoEmailInfoTag) {
    /** Untagged email address. */
    FormFieldContactInfoEmailInfoTag["UNTAGGED"] = "UNTAGGED";
    /** Primary email address for the contact. */
    FormFieldContactInfoEmailInfoTag["MAIN"] = "MAIN";
})(FormFieldContactInfoEmailInfoTag || (FormFieldContactInfoEmailInfoTag = {}));
export var FormFieldContactInfoPhoneInfoTag;
(function (FormFieldContactInfoPhoneInfoTag) {
    /** Untagged phone number. */
    FormFieldContactInfoPhoneInfoTag["UNTAGGED"] = "UNTAGGED";
    /** Primary phone number for the contact. */
    FormFieldContactInfoPhoneInfoTag["MAIN"] = "MAIN";
})(FormFieldContactInfoPhoneInfoTag || (FormFieldContactInfoPhoneInfoTag = {}));
export var AddressInfoTag;
(function (AddressInfoTag) {
    /** Untagged address. */
    AddressInfoTag["UNTAGGED"] = "UNTAGGED";
    /** Home address. */
    AddressInfoTag["HOME"] = "HOME";
})(AddressInfoTag || (AddressInfoTag = {}));
export var ConfirmationLevel;
(function (ConfirmationLevel) {
    /** Unknown confirmation level. */
    ConfirmationLevel["UNKNOWN_CONFIRMATION_LEVEL"] = "UNKNOWN_CONFIRMATION_LEVEL";
    /** Single confirmation level. */
    ConfirmationLevel["SINGLE_CONFIRMATION"] = "SINGLE_CONFIRMATION";
    /** Double confirmation level. */
    ConfirmationLevel["DOUBLE_CONFIRMATION"] = "DOUBLE_CONFIRMATION";
})(ConfirmationLevel || (ConfirmationLevel = {}));
export var FormFieldContactInfoContactField;
(function (FormFieldContactInfoContactField) {
    FormFieldContactInfoContactField["UNKNOWN_CONTACT_FIELD"] = "UNKNOWN_CONTACT_FIELD";
    /** Contact's first name. */
    FormFieldContactInfoContactField["FIRST_NAME"] = "FIRST_NAME";
    /** Contact's last name. */
    FormFieldContactInfoContactField["LAST_NAME"] = "LAST_NAME";
    /** Contact's company or organization. */
    FormFieldContactInfoContactField["COMPANY"] = "COMPANY";
    /** Contact's job title or position. */
    FormFieldContactInfoContactField["POSITION"] = "POSITION";
    /** Contact's email address. */
    FormFieldContactInfoContactField["EMAIL"] = "EMAIL";
    /** Contact's phone number. */
    FormFieldContactInfoContactField["PHONE"] = "PHONE";
    /** Contact's physical address. */
    FormFieldContactInfoContactField["ADDRESS"] = "ADDRESS";
    /** Contact's birth date. */
    FormFieldContactInfoContactField["BIRTHDATE"] = "BIRTHDATE";
    /** Custom contact field defined by the site owner. */
    FormFieldContactInfoContactField["CUSTOM_FIELD"] = "CUSTOM_FIELD";
    /** Contact's subscription preferences. */
    FormFieldContactInfoContactField["SUBSCRIPTION"] = "SUBSCRIPTION";
    /** Contact's VAT identification number. */
    FormFieldContactInfoContactField["VAT_ID"] = "VAT_ID";
})(FormFieldContactInfoContactField || (FormFieldContactInfoContactField = {}));
export var DisplayFieldDisplayFieldType;
(function (DisplayFieldDisplayFieldType) {
    /** Unknown field type. */
    DisplayFieldDisplayFieldType["UNKNOWN_FIELD_TYPE"] = "UNKNOWN_FIELD_TYPE";
    /** Rich content display field. */
    DisplayFieldDisplayFieldType["RICH_CONTENT"] = "RICH_CONTENT";
    /** Page navigation display field. */
    DisplayFieldDisplayFieldType["PAGE_NAVIGATION"] = "PAGE_NAVIGATION";
    /** Login bar display field. */
    DisplayFieldDisplayFieldType["LOGIN_BAR"] = "LOGIN_BAR";
})(DisplayFieldDisplayFieldType || (DisplayFieldDisplayFieldType = {}));
export var OverrideEntityType;
(function (OverrideEntityType) {
    /** Unknown override entity type. */
    OverrideEntityType["UNKNOWN"] = "UNKNOWN";
    /** Override applies to a form field. */
    OverrideEntityType["FIELD"] = "FIELD";
    /** Override applies to the form itself. */
    OverrideEntityType["FORM"] = "FORM";
    /** Override applies to a field within a nested form. */
    OverrideEntityType["NESTED_FORM_FIELD"] = "NESTED_FORM_FIELD";
})(OverrideEntityType || (OverrideEntityType = {}));
export var Kind;
(function (Kind) {
    /** Return forms specific to tenant, excluding template based forms. */
    Kind["REGULAR"] = "REGULAR";
    /** Return forms based on common templates, with applied user overrides if they exist. */
    Kind["EXTENSION"] = "EXTENSION";
})(Kind || (Kind = {}));
export var EmailInfoTag;
(function (EmailInfoTag) {
    /** Email without a specific tag. */
    EmailInfoTag["UNTAGGED"] = "UNTAGGED";
    /** Primary email address for the contact. */
    EmailInfoTag["MAIN"] = "MAIN";
})(EmailInfoTag || (EmailInfoTag = {}));
export var PhoneInfoTag;
(function (PhoneInfoTag) {
    /** Phone number without a specific tag. */
    PhoneInfoTag["UNTAGGED"] = "UNTAGGED";
    /** Primary phone number for the contact. */
    PhoneInfoTag["MAIN"] = "MAIN";
})(PhoneInfoTag || (PhoneInfoTag = {}));
export var Tag;
(function (Tag) {
    /** Address without a specific tag. */
    Tag["UNTAGGED"] = "UNTAGGED";
    /** Home address for the contact. */
    Tag["HOME"] = "HOME";
})(Tag || (Tag = {}));
export var OptInLevel;
(function (OptInLevel) {
    /** Unknown opt-in level. */
    OptInLevel["UNKNOWN"] = "UNKNOWN";
    /** Single confirmation opt-in. The contact is subscribed immediately. */
    OptInLevel["SINGLE_CONFIRMATION"] = "SINGLE_CONFIRMATION";
    /** Double confirmation opt-in. The contact must confirm their subscription via email. */
    OptInLevel["DOUBLE_CONFIRMATION"] = "DOUBLE_CONFIRMATION";
})(OptInLevel || (OptInLevel = {}));
export var ContactField;
(function (ContactField) {
    /** Unknown contact field. */
    ContactField["UNDEFINED"] = "UNDEFINED";
    /** First name. */
    ContactField["FIRST_NAME"] = "FIRST_NAME";
    /** CLast name. */
    ContactField["LAST_NAME"] = "LAST_NAME";
    /** Company name. */
    ContactField["COMPANY"] = "COMPANY";
    /** Job position or title. */
    ContactField["POSITION"] = "POSITION";
    /** Email address. */
    ContactField["EMAIL"] = "EMAIL";
    /** Phone number. */
    ContactField["PHONE"] = "PHONE";
    /** Physical address. */
    ContactField["ADDRESS"] = "ADDRESS";
    /** Birth date. */
    ContactField["BIRTHDATE"] = "BIRTHDATE";
    /** Custom field. */
    ContactField["CUSTOM_FIELD"] = "CUSTOM_FIELD";
    /** Subscription status. */
    ContactField["SUBSCRIPTION"] = "SUBSCRIPTION";
    /** VAT identification number. */
    ContactField["VAT_ID"] = "VAT_ID";
})(ContactField || (ContactField = {}));
export var SpamFilterProtectionLevel;
(function (SpamFilterProtectionLevel) {
    /** Unknown spam filter protection level. */
    SpamFilterProtectionLevel["UNKNOWN"] = "UNKNOWN";
    /** No spam filtering. All submissions are accepted without screening. */
    SpamFilterProtectionLevel["NONE"] = "NONE";
    /** Basic spam filtering. Provides minimal protection against obvious spam and the form is open to a high risk of spam submissions. */
    SpamFilterProtectionLevel["BASIC"] = "BASIC";
    /** Advanced spam filtering. Provides comprehensive protection with intelligent screening and the form is open to a low risk of spam submissions. */
    SpamFilterProtectionLevel["ADVANCED"] = "ADVANCED";
})(SpamFilterProtectionLevel || (SpamFilterProtectionLevel = {}));
export var RequiredIndicator;
(function (RequiredIndicator) {
    /** Unknown required indicator type. */
    RequiredIndicator["UNKNOWN_INDICATOR"] = "UNKNOWN_INDICATOR";
    /** Display an asterisk (*) symbol to indicate required fields. */
    RequiredIndicator["ASTERISK"] = "ASTERISK";
    /** Display the text "Required" to indicate required fields. */
    RequiredIndicator["TEXT"] = "TEXT";
    /** No visual indicator is shown for required fields. */
    RequiredIndicator["NONE"] = "NONE";
})(RequiredIndicator || (RequiredIndicator = {}));
export var RequiredIndicatorPlacement;
(function (RequiredIndicatorPlacement) {
    /** Unknown required indicator placement. */
    RequiredIndicatorPlacement["UNKNOWN_PLACEMENT"] = "UNKNOWN_PLACEMENT";
    /** Place the required indicator after the field title. */
    RequiredIndicatorPlacement["AFTER_FIELD_TITLE"] = "AFTER_FIELD_TITLE";
    /** Place the required indicator before the field title. */
    RequiredIndicatorPlacement["BEFORE_FIELD_TITLE"] = "BEFORE_FIELD_TITLE";
})(RequiredIndicatorPlacement || (RequiredIndicatorPlacement = {}));
export var UrlTargetEnumTarget;
(function (UrlTargetEnumTarget) {
    /** Unknown target behavior. */
    UrlTargetEnumTarget["UNKNOWN_TARGET"] = "UNKNOWN_TARGET";
    /** Open the URL in the same browser tab, replacing the current page. */
    UrlTargetEnumTarget["SELF"] = "SELF";
    /** Open the URL in a new browser tab. */
    UrlTargetEnumTarget["BLANK"] = "BLANK";
})(UrlTargetEnumTarget || (UrlTargetEnumTarget = {}));
export var SubmitSuccessAction;
(function (SubmitSuccessAction) {
    /** Unknown submit success action. */
    SubmitSuccessAction["UNKNOWN_SUBMIT_SUCCESS_ACTION"] = "UNKNOWN_SUBMIT_SUCCESS_ACTION";
    /** No action is taken after form submission. */
    SubmitSuccessAction["NO_ACTION"] = "NO_ACTION";
    /** Display a thank you message after form submission. */
    SubmitSuccessAction["THANK_YOU_MESSAGE"] = "THANK_YOU_MESSAGE";
    /** Redirect the user to a specified URL after form submission. */
    SubmitSuccessAction["REDIRECT"] = "REDIRECT";
})(SubmitSuccessAction || (SubmitSuccessAction = {}));
/** Enum for different types of field properties that can be modified by rules. */
export var ChangeableProperty;
(function (ChangeableProperty) {
    /** Unknown property type. */
    ChangeableProperty["UNKNOWN_CHANGEABLE_PROPERTY"] = "UNKNOWN_CHANGEABLE_PROPERTY";
    /** Required property type. */
    ChangeableProperty["REQUIRED"] = "REQUIRED";
    /** Hidden property type. */
    ChangeableProperty["HIDDEN"] = "HIDDEN";
    /** Allowed values property type. */
    ChangeableProperty["ALLOWED_VALUES"] = "ALLOWED_VALUES";
})(ChangeableProperty || (ChangeableProperty = {}));
export var OverrideEntityTypeEnumOverrideEntityType;
(function (OverrideEntityTypeEnumOverrideEntityType) {
    /** Unknown override entity type. */
    OverrideEntityTypeEnumOverrideEntityType["UNKNOWN_OVERRIDE_ENTITY_TYPE"] = "UNKNOWN_OVERRIDE_ENTITY_TYPE";
    /** Override applies to a form field. */
    OverrideEntityTypeEnumOverrideEntityType["FIELD"] = "FIELD";
})(OverrideEntityTypeEnumOverrideEntityType || (OverrideEntityTypeEnumOverrideEntityType = {}));
export var Operator;
(function (Operator) {
    Operator["UNKNOWN_OPERATOR"] = "UNKNOWN_OPERATOR";
    /** Specified value equals the value in the target field. */
    Operator["EQUAL"] = "EQUAL";
    /** Specified value doesn't equal the value in the target field. */
    Operator["NOT_EQUAL"] = "NOT_EQUAL";
    /** Target field is empty or has no value. */
    Operator["EMPTY"] = "EMPTY";
    /** Target field isn't empty and has a value. */
    Operator["NOT_EMPTY"] = "NOT_EMPTY";
    /** String value in the target field contains the specified substring. */
    Operator["CONTAINS"] = "CONTAINS";
    /** String value in the target field doesn't contain the specified substring. */
    Operator["NOT_CONTAINS"] = "NOT_CONTAINS";
    /** Numeric value in the target field is less than the specified value. */
    Operator["LESS_THAN"] = "LESS_THAN";
    /** Numeric value in the target field is less than or equal to the specified value. */
    Operator["LESS_THAN_OR_EQUALS"] = "LESS_THAN_OR_EQUALS";
    /** Numeric value in the target field is greater than the specified value. */
    Operator["GREATER_THAN"] = "GREATER_THAN";
    /** Numeric value in the target field is greater than or equal to the specified value. */
    Operator["GREATER_THAN_OR_EQUALS"] = "GREATER_THAN_OR_EQUALS";
    /** Date value in the target field is before the specified date. */
    Operator["BEFORE"] = "BEFORE";
    /** Date value in the target field is before or equal to the specified date. */
    Operator["BEFORE_OR_EQUAL"] = "BEFORE_OR_EQUAL";
    /** Date value in the target field is after the specified date. */
    Operator["AFTER"] = "AFTER";
    /** Date value in the target field is after or equal to the specified date. */
    Operator["AFTER_OR_EQUAL"] = "AFTER_OR_EQUAL";
    /** Value in the target field falls within the specified range. */
    Operator["BETWEEN"] = "BETWEEN";
    /** Value in the target field matches any of the specified values. */
    Operator["ANY"] = "ANY";
    /** Array value in the target field exactly equals the specified array. */
    Operator["ARRAY_EQUAL"] = "ARRAY_EQUAL";
    /** Array value in the target field doesn't equal the specified array. */
    Operator["ARRAY_NOT_EQUAL"] = "ARRAY_NOT_EQUAL";
    /** Checkbox or boolean field value in the target field is checked. */
    Operator["CHECKED"] = "CHECKED";
    /** Checkbox or boolean field value in the target field isn't checked. */
    Operator["NOT_CHECKED"] = "NOT_CHECKED";
    /** Value in the target field is included in the specified list. */
    Operator["IN"] = "IN";
    /** Value in the target field isn't included in the specified list. */
    Operator["NOT_IN"] = "NOT_IN";
    /** Date value in the target field is older than the specified time period. */
    Operator["IS_DATE_OLDER_THAN"] = "IS_DATE_OLDER_THAN";
    /** Date value in the target field is older than or equal to the specified time period. */
    Operator["IS_DATE_OLDER_THAN_OR_EQUAL"] = "IS_DATE_OLDER_THAN_OR_EQUAL";
    /** Date value in the target field is newer than the specified time period. */
    Operator["IS_DATE_NEWER_THAN"] = "IS_DATE_NEWER_THAN";
    /** Date value in the target field is newer than or equal to the specified time period. */
    Operator["IS_DATE_NEWER_THAN_OR_EQUAL"] = "IS_DATE_NEWER_THAN_OR_EQUAL";
})(Operator || (Operator = {}));
export var Fieldset;
(function (Fieldset) {
    Fieldset["UNKNOWN"] = "UNKNOWN";
    /** Include nested form fields in the response. */
    Fieldset["NESTED_FORMS"] = "NESTED_FORMS";
})(Fieldset || (Fieldset = {}));
export var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder || (SortOrder = {}));
export var CountFormsFieldset;
(function (CountFormsFieldset) {
    CountFormsFieldset["UNKNOWN"] = "UNKNOWN";
    /** Include deleted forms count. */
    CountFormsFieldset["DELETED"] = "DELETED";
})(CountFormsFieldset || (CountFormsFieldset = {}));
export var ListFormsOrderEnumListFormsOrder;
(function (ListFormsOrderEnumListFormsOrder) {
    /** Sort by updated date in descending order. Default. */
    ListFormsOrderEnumListFormsOrder["UPDATED_DATE_DESC"] = "UPDATED_DATE_DESC";
    /** Sort by updated date in ascending order . */
    ListFormsOrderEnumListFormsOrder["UPDATED_DATE_ASC"] = "UPDATED_DATE_ASC";
    /** Sort by created date in ascending order. */
    ListFormsOrderEnumListFormsOrder["CREATED_DATE_ASC"] = "CREATED_DATE_ASC";
    /** Sort by created date in descending order. */
    ListFormsOrderEnumListFormsOrder["CREATED_DATE_DESC"] = "CREATED_DATE_DESC";
    /** Sort by name in ascending order. */
    ListFormsOrderEnumListFormsOrder["NAME_ASC"] = "NAME_ASC";
    /** Sort by name in descending order. */
    ListFormsOrderEnumListFormsOrder["NAME_DESC"] = "NAME_DESC";
})(ListFormsOrderEnumListFormsOrder || (ListFormsOrderEnumListFormsOrder = {}));
export var FilterType;
(function (FilterType) {
    /** Return form schemas with names that exactly match the specified name. */
    FilterType["EXACT_MATCH"] = "EXACT_MATCH";
    /** Return form schemas with names that start with the specified name. */
    FilterType["STARTS_WITH"] = "STARTS_WITH";
})(FilterType || (FilterType = {}));
export var ListFormsOrder;
(function (ListFormsOrder) {
    /** Sort by updated date in descending order. Default. */
    ListFormsOrder["UPDATED_DATE_DESC"] = "UPDATED_DATE_DESC";
    /** Sort by updated date in ascending order. */
    ListFormsOrder["UPDATED_DATE_ASC"] = "UPDATED_DATE_ASC";
    /** Sort by created date in ascending order. */
    ListFormsOrder["CREATED_DATE_ASC"] = "CREATED_DATE_ASC";
    /** Sort by created date in descending order. */
    ListFormsOrder["CREATED_DATE_DESC"] = "CREATED_DATE_DESC";
    /** Sort by name in ascending order. */
    ListFormsOrder["NAME_ASC"] = "NAME_ASC";
    /** Sort by name in descending order. */
    ListFormsOrder["NAME_DESC"] = "NAME_DESC";
})(ListFormsOrder || (ListFormsOrder = {}));
export var ListDeletedFormsOrder;
(function (ListDeletedFormsOrder) {
    /** Sort by updated date in descending order. Default. */
    ListDeletedFormsOrder["UPDATED_DATE_DESC"] = "UPDATED_DATE_DESC";
    /** Sort by updated date in ascending order. */
    ListDeletedFormsOrder["UPDATED_DATE_ASC"] = "UPDATED_DATE_ASC";
    /** Sort by name in descending order. */
    ListDeletedFormsOrder["NAME_DESC"] = "NAME_DESC";
    /** Sort by name in ascending order. */
    ListDeletedFormsOrder["NAME_ASC"] = "NAME_ASC";
})(ListDeletedFormsOrder || (ListDeletedFormsOrder = {}));
export var FieldInputType;
(function (FieldInputType) {
    /** Unknown input type. */
    FieldInputType["UNKNOWN_INPUT_TYPE"] = "UNKNOWN_INPUT_TYPE";
    /** String input. */
    FieldInputType["STRING"] = "STRING";
    /** Numeric input. */
    FieldInputType["NUMBER"] = "NUMBER";
    /** Rating input. */
    FieldInputType["RATING"] = "RATING";
    /** Boolean input. */
    FieldInputType["BOOLEAN"] = "BOOLEAN";
    /** Array input. */
    FieldInputType["ARRAY"] = "ARRAY";
    /** Object input. */
    FieldInputType["OBJECT"] = "OBJECT";
    /** File upload input. */
    FieldInputType["WIX_FILE"] = "WIX_FILE";
    /** Digital signature input. */
    FieldInputType["SIGNATURE"] = "SIGNATURE";
    /** Payment input. */
    FieldInputType["PAYMENT"] = "PAYMENT";
    /** Multi-line address input. */
    FieldInputType["MULTILINE_ADDRESS"] = "MULTILINE_ADDRESS";
    /** Date input. */
    FieldInputType["DATE"] = "DATE";
    /** Time input. */
    FieldInputType["TIME"] = "TIME";
    /** Combined date and time input. */
    FieldInputType["DATE_TIME"] = "DATE_TIME";
    /** Email input. */
    FieldInputType["EMAIL"] = "EMAIL";
    /** URL input. */
    FieldInputType["URL"] = "URL";
    /** UUID input. */
    FieldInputType["UUID"] = "UUID";
    /** Phone number input. */
    FieldInputType["PHONE"] = "PHONE";
    /** URI input. */
    FieldInputType["URI"] = "URI";
    /** Hostname input. */
    FieldInputType["HOSTNAME"] = "HOSTNAME";
    /** Color input. */
    FieldInputType["COLOR_HEX"] = "COLOR_HEX";
    /** Currency input. */
    FieldInputType["CURRENCY"] = "CURRENCY";
    /** Language input. */
    FieldInputType["LANGUAGE"] = "LANGUAGE";
    /** Date input with optional time component. */
    FieldInputType["DATE_OPTIONAL_TIME"] = "DATE_OPTIONAL_TIME";
})(FieldInputType || (FieldInputType = {}));
export var WebhookIdentityType;
(function (WebhookIdentityType) {
    WebhookIdentityType["UNKNOWN"] = "UNKNOWN";
    WebhookIdentityType["ANONYMOUS_VISITOR"] = "ANONYMOUS_VISITOR";
    WebhookIdentityType["MEMBER"] = "MEMBER";
    WebhookIdentityType["WIX_USER"] = "WIX_USER";
    WebhookIdentityType["APP"] = "APP";
})(WebhookIdentityType || (WebhookIdentityType = {}));
//# sourceMappingURL=types.impl.js.map